import { render, staticRenderFns } from "./PrivilegiosComponent.vue?vue&type=template&id=e0626040&"
import script from "./PrivilegiosComponent.vue?vue&type=script&lang=js&"
export * from "./PrivilegiosComponent.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegiosComponent.vue?vue&type=style&index=0&id=e0626040&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports